import React from 'react';
import PropTypes from 'prop-types';
import Sentry from 'modules/sentry';
// import Raven from 'raven-js';

export default class ErrorBoundary extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  state = { error: null };

  componentDidCatch(error, errorInfo) {
    this.setState({ error });
    Sentry.captureException(error, { extra: errorInfo });
  }

  render() {
    if (this.state.error) {
      return (
        <div className="alert alert-primary text-center" role="alert">
          <h2 className="alert-heading">Uh oh.</h2>
          <p>
            The dev team can see this crash, but make sure you let them know the
            context of how this happened so they can help fix it.
          </p>
          <hr />
          <img
            alt="He's dead, Jim"
            src="https://media.giphy.com/media/qH7J4EXzSCmBy/giphy.gif"
          />
        </div>
      );
    }
    // when there's not an error, render children untouched
    return this.props.children;
  }
}
